import { render, staticRenderFns } from "./deletetitle.vue?vue&type=template&id=1a4965c1&scoped=true"
import script from "./deletetitle.vue?vue&type=script&lang=js"
export * from "./deletetitle.vue?vue&type=script&lang=js"
import style0 from "./deletetitle.vue?vue&type=style&index=0&id=1a4965c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4965c1",
  null
  
)

export default component.exports